// ==============================
// メインJavaScript
// ==============================

// jQueryをインポート
import $ from 'jquery';

// グローバルに$とjQueryを設定（既存のプラグインで必要な場合）
window.$ = window.jQuery = $;

// DOMの読み込み完了後に実行
$(document).ready(function() {
    // ここにメインのJavaScriptコードを記述

    // モバイルメニュー
    var _createClass = (function () {
        function a(e, c) {
            for (var b = 0; b < c.length; b++) {
                var d = c[b];
                d.enumerable = d.enumerable || false;
                d.configurable = true;
                if ('value' in d) {
                    d.writable = true;
                }
                Object.defineProperty(e, d.key, d);
            }
        }
        return function (d, b, c) {
            if (b) {
                a(d.prototype, b);
            }
            if (c) {
                a(d, c);
            }
            return d;
        };
    })();
    function _classCallCheck(a, b) {
        if (!(a instanceof b)) {
            throw new TypeError('Cannot call a class as a function');
        }
    }
    var Pushbar = (function () {
        function i() {
            var m =
                arguments.length > 0 && arguments[0] !== undefined
                    ? arguments[0]
                    : { overlay: true, blur: false };
            _classCallCheck(this, i);
            this.activeBar = null;
            this.overlay = false;
            if (m.overlay) {
                this.overlay = document.createElement('div');
                this.overlay.classList.add('pushbar_overlay');
                document.querySelector('body').appendChild(this.overlay);
            }
            if (m.blur) {
                var l = document.querySelector('.pushbar_main_content');
                if (l) {
                    l.classList.add('pushbar_blur');
                }
            }
            this.bindEvents();
        }
        _createClass(
            i,
            [
                {
                    key: 'handleOpenEvent',
                    value: function a(l) {
                        l.preventDefault();
                        var m = l.currentTarget.getAttribute('data-pushbar-target');
                        if (m) {
                            this.open(m);
                        }
                    },
                },
                {
                    key: 'handleCloseEvent',
                    value: function k(l) {
                        l.preventDefault();
                        this.close();
                    },
                },
                {
                    key: 'handleKeyEvent',
                    value: function g(l) {
                        if (this.opened && l.keyCode === 27) {
                            this.close();
                        }
                    },
                },
                {
                    key: 'bindEvents',
                    value: function c() {
                        var n = this;
                        var m = document.querySelectorAll('[data-pushbar-target]');
                        var l = document.querySelectorAll('[data-pushbar-close]');
                        m.forEach(function (o) {
                            return o.addEventListener(
                                'click',
                                function (p) {
                                    return n.handleOpenEvent(p);
                                },
                                false
                            );
                        });
                        l.forEach(function (o) {
                            return o.addEventListener(
                                'click',
                                function (p) {
                                    return n.handleCloseEvent(p);
                                },
                                false
                            );
                        });
                        if (this.overlay) {
                            this.overlay.addEventListener(
                                'click',
                                function (o) {
                                    return n.handleCloseEvent(o);
                                },
                                false
                            );
                        }
                        document.addEventListener('keyup', function (o) {
                            return n.handleKeyEvent(o);
                        });
                    },
                },
                {
                    key: 'open',
                    value: function f(n) {
                        if (String(n) === this.activeBarId && this.opened) {
                            return;
                        }
                        var l = i.findElementById(n);
                        if (!l) {
                            return;
                        }
                        if (this.opened) {
                            this.close();
                        }
                        i.dispatchOpen(l);
                        l.classList.add('opened');
                        var m = document.querySelector('html');
                        m.classList.add('pushbar_locked');
                        m.setAttribute('pushbar', n);
                        this.activeBar = l;
                    },
                },
                {
                    key: 'close',
                    value: function j() {
                        var l = this.activeBar;
                        if (!l) {
                            return;
                        }
                        i.dispatchClose(l);
                        l.classList.remove('opened');
                        var m = document.querySelector('html');
                        m.classList.remove('pushbar_locked');
                        m.removeAttribute('pushbar');
                        this.activeBar = null;
                    },
                },
                {
                    key: 'opened',
                    get: function b() {
                        var l = this.activeBar;
                        return Boolean(l instanceof HTMLElement && l.classList.contains('opened'));
                    },
                },
                {
                    key: 'activeBarId',
                    get: function b() {
                        var l = this.activeBar;
                        return l instanceof HTMLElement && l.getAttribute('data-pushbar-id');
                    },
                },
            ],
            [
                {
                    key: 'dispatchOpen',
                    value: function d(l) {
                        var m = new CustomEvent('pushbar_opening', {
                            bubbles: true,
                            detail: { pushbar: l },
                        });
                        l.dispatchEvent(m);
                    },
                },
                {
                    key: 'dispatchClose',
                    value: function h(l) {
                        var m = new CustomEvent('pushbar_closing', {
                            bubbles: true,
                            detail: { pushbar: l },
                        });
                        l.dispatchEvent(m);
                    },
                },
                {
                    key: 'findElementById',
                    value: function e(l) {
                        return document.querySelector('[data-pushbar-id="' + l + '"]');
                    },
                },
            ]
        );
        return i;
    })();
    // ==============================
    // モバイルメニュー（Pushbar）の初期化制御
    // ==============================

    // メディアクエリで991px以下（モバイル表示）の場合のみPushbarを初期化
    const mobileMediaQuery = window.matchMedia('(max-width: 991px)');
    let pushbar = null;

    function initPushbar() {
        if (mobileMediaQuery.matches && !pushbar) {
            // モバイル表示時のみPushbarを初期化
            pushbar = new Pushbar({ blur: true, overlay: true });

            // Pushbar要素を表示可能にする（FOUC対策）
            const pushbarElement = document.querySelector('.pushbar');
            if (pushbarElement) {
                pushbarElement.style.visibility = 'visible';
            }
        }
    }

    function destroyPushbar() {
        if (!mobileMediaQuery.matches && pushbar) {
            // PC表示に切り替わった際にメニューを閉じる
            if (pushbar.opened) {
                pushbar.close();
            }
            // オーバーレイ要素を削除
            const overlay = document.querySelector('.pushbar_overlay');
            if (overlay) {
                overlay.remove();
            }
            pushbar = null;
        }
    }

    // 初期化
    initPushbar();

    // ウィンドウリサイズ時に再評価
    mobileMediaQuery.addEventListener('change', (e) => {
        if (e.matches) {
            // モバイル表示に切り替わった場合
            initPushbar();
        } else {
            // PC表示に切り替わった場合
            destroyPushbar();
        }
    });

    // ==============================
    // PC表示時のスクロール制御（自作スムーススクロール版）
    // ==============================

    const mediaQuery = window.matchMedia('(min-width: 576px)');
    let smoothScroll = null;

    class SmoothScroll {
        constructor(element) {
            this.element = element;
            this.targetScroll = 0;
            this.currentScroll = 0;
            this.ease = 0.08; // 慣性の強さ（0.05=とても滑らか、0.2=速い）
            this.rafId = null;
            this.wheelHandler = null;

            this.init();
        }

        init() {
            // 初期スクロール位置を取得
            this.targetScroll = this.element.scrollTop;
            this.currentScroll = this.element.scrollTop;

            // ページ全体のwheelイベントをキャッチ
            this.wheelHandler = (e) => {
                e.preventDefault();

                // スクロール量の調整（ここで簡単に変更可能！）
                this.targetScroll += e.deltaY * 0.8;

                // スクロール範囲を制限
                const maxScroll = this.element.scrollHeight - this.element.clientHeight;
                this.targetScroll = Math.max(0, Math.min(this.targetScroll, maxScroll));
            };

            document.addEventListener('wheel', this.wheelHandler, { passive: false });

            // アニメーションループ開始
            this.animate();
        }

        animate() {
            // イージング計算（現在位置から目標位置へ徐々に移動）
            this.currentScroll += (this.targetScroll - this.currentScroll) * this.ease;

            // 実際にスクロールを適用
            this.element.scrollTop = this.currentScroll;

            // 次のフレームへ
            this.rafId = requestAnimationFrame(() => this.animate());
        }

        scrollTo(position) {
            // スクロール範囲を制限
            const maxScroll = this.element.scrollHeight - this.element.clientHeight;
            this.targetScroll = Math.max(0, Math.min(position, maxScroll));
        }

        destroy() {
            if (this.wheelHandler) {
                document.removeEventListener('wheel', this.wheelHandler);
            }
            if (this.rafId) {
                cancelAnimationFrame(this.rafId);
            }
        }
    }

    function initSmoothScroll() {
        if (mediaQuery.matches && !smoothScroll) {
            const mobileElement = document.querySelector('.mobile');
            if (mobileElement) {
                smoothScroll = new SmoothScroll(mobileElement);
            }
        }
    }

    function destroySmoothScroll() {
        if (smoothScroll) {
            smoothScroll.destroy();
            smoothScroll = null;
        }
    }

    // 初期化
    initSmoothScroll();

    // ウィンドウリサイズ時に再評価
    mediaQuery.addEventListener('change', (e) => {
        if (e.matches) {
            // PC表示に切り替わった場合
            initSmoothScroll();
        } else {
            // モバイル表示に切り替わった場合
            destroySmoothScroll();
        }
    });

    // ==============================
    // ページ内アンカーリンク対応
    // ==============================
    // 同ページ内のアンカーリンククリック時の処理
    document.addEventListener('click', function(e) {
        const target = e.target.closest('a[href*="#"]');
        if (!target) return;

        const href = target.getAttribute('href');
        if (!href || href === '#') return;

        // ハッシュ部分を取得
        const hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;

        const hash = href.substring(hashIndex);
        const targetElement = document.querySelector(hash);
        if (!targetElement) return;

        // 同ページ内のアンカーリンクのみ処理
        const currentPath = location.pathname.split('/').pop();
        const linkPath = href.substring(0, hashIndex);
        const isSamePage = !linkPath || linkPath === currentPath || linkPath === location.pathname;

        if (!isSamePage) return;

        e.preventDefault();

        // pushbarが開いている場合は閉じる
        if (pushbar && pushbar.opened) {
            pushbar.close();
        }

        // ヘッダーの高さ + 余白を計算
        const header = document.querySelector('.l-header');
        let offset = 0;
        if (header) {
            offset = header.offsetHeight + 40; // ヘッダーの高さ + 余白20px
        }

        // PC表示時（スムーススクロール有効時）
        if (mediaQuery.matches && smoothScroll) {
            const mobileElement = document.querySelector('.mobile');
            if (mobileElement) {
                const rect = targetElement.getBoundingClientRect();
                const mobileRect = mobileElement.getBoundingClientRect();
                const targetPosition = rect.top - mobileRect.top + mobileElement.scrollTop - offset;
                smoothScroll.scrollTo(targetPosition);
            }
        }
        // モバイル表示時
        else {
            const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        }
    });

    // ==============================
    // アコーディオン
    // ==============================
    $('.p-question__accordion-txt').hide();
    $('.p-question__accordion-ttl').on('click', function () {
        $(this).toggleClass('active');
        $(this).next('.p-question__accordion-txt').slideToggle('fast');
    });
});

// 既存のJavaScriptを統合する場合は、ここでインポート
// import './modules/slider';
// import './modules/navigation';
